module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passport-field"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, _vm._l((_vm.fields), function(field, idx) {
    return (_vm.fieldVisibility(idx)) ? _c('div', {
      key: idx,
      staticClass: "w5-field",
      class: idx + (idx === 'num' && _vm.country !== 'RU' ? ' union' : '')
    }, [_c('div', {
      staticClass: "w5-field-placeholder",
      class: {
        'active': field.focused || field.value, 'readonly': _vm.readonly === true
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(field.title))), (_vm.required) ? _c('span', {
      staticClass: "required-field"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), (idx === 'date') ? [_c('manualDateComponent', {
      class: {
        'haserror': _vm.errorMessage || field.error
      },
      attrs: {
        "disabled": _vm.readonly === true ? 'disabled' : false
      },
      on: {
        "error": _vm.onDateError,
        "focus": function($event) {
          return _vm.onFocus('date')
        },
        "blur": function($event) {
          return _vm.onBlur('date')
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.enterKeyDown($event)
        },
        "input": function($event) {
          return _vm.onInput('date', $event)
        }
      },
      model: {
        value: (_vm.fields.date.value),
        callback: function($$v) {
          _vm.$set(_vm.fields.date, "value", $$v)
        },
        expression: "fields.date.value"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.error),
        expression: "field.error"
      }, {
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc(field.error)),
        expression: "localeFtc(field.error)"
      }],
      staticClass: "alert alert-danger w5-alert-valid",
      attrs: {
        "role": "alert"
      }
    })] : (_vm.fieldVisibility(idx)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.value),
        expression: "field.value"
      }],
      ref: idx,
      refInFor: true,
      class: {
        'haserror': _vm.errorMessage || _vm.fields.date.error
      },
      attrs: {
        "type": "text",
        "disabled": _vm.readonly === true ? 'disabled' : false
      },
      domProps: {
        "value": (field.value)
      },
      on: {
        "focus": function($event) {
          return _vm.onFocus(idx)
        },
        "blur": function($event) {
          return _vm.onBlur(idx)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.enterKeyDown($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "value", $event.target.value)
        }, function($event) {
          return _vm.onInput(idx, $event)
        }]
      }
    }) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.focused && !field.error),
        expression: "field.focused && !field.error"
      }],
      staticClass: "w5-tooltip-wrapper"
    }, [_c('span', {
      staticClass: "w5-tooltip"
    }, [_vm._v(_vm._s(_vm._f("ftc")(field.hint)))])])])], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage && !_vm.fields.date.error),
      expression: "errorMessage && !fields.date.error"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errorMessage)),
      expression: "localeFtc(errorMessage)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c7f0cde"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/passport.vue
// module id = 420
// module chunks = 0